import { render, staticRenderFns } from "./KnowledgeGraphHome.vue?vue&type=template&id=184f0c2e&scoped=true&"
import script from "./KnowledgeGraphHome.vue?vue&type=script&lang=js&"
export * from "./KnowledgeGraphHome.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeGraphHome.vue?vue&type=style&index=0&id=184f0c2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f0c2e",
  null
  
)

export default component.exports